import { i18n } from 'utils/i18n';

export class BaseError extends Error {}

export class LimitReached extends BaseError {
  constructor() {
    super(i18n.t('errors:limit_reached'));
  }
}
